import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { trackEvent } from 'dibs-tracking';
import classnames from 'classnames';

import styles from './SiteNav-style.scss';

// Current image container has a width to height ratio of 2:1
const CONTAINER_HEIGHT_RATIO_FACTOR = 1;
const CONTAINER_WIDTH_RATIO_FACTOR = 2;

const trackClick = () => {
    trackEvent({
        category: 'navigation',
        action: 'header navigation clicked',
        label: 'trending now',
    });
};

const SiteNavDropdownImageModuleComponent = ({ navigationModule }) => {
    const {
        imageUrl,
        imageLink,
        imageTitlePrimary,
        imageTitleSecondary,
        imageHeight,
        imageWidth,
    } = navigationModule;

    if (!imageUrl) {
        return null;
    }
    const containerRatio = CONTAINER_WIDTH_RATIO_FACTOR / CONTAINER_HEIGHT_RATIO_FACTOR;
    const imageWidthNum = Number(imageWidth.replace('px', ''));
    const imageHeightNum = Number(imageHeight.replace('px', ''));
    const imageRatio = imageWidthNum / imageHeightNum;

    const imageClasses = classnames(styles.imageModuleImage, {
        // If ratio of image is less than container ratio,
        // need to set image width to 100% (with variable height).
        // This is because any image with a width less than twice
        // it's height - even landscape images - will not fill
        // container if the image height is set to 100% (with variable width)
        // Figured out with the help of:
        // https://medium.com/@elad/how-to-crop-images-with-css-b8471d402b16
        [styles.setWidth]: imageRatio < containerRatio,
    });

    const imageEl = (
        <div className={styles.imageModuleWrapper}>
            <div className={styles.imageBox}>
                <img className={imageClasses} src={imageUrl} />
            </div>
            <div className={styles.titleBox}>
                {imageTitleSecondary && (
                    <div className={styles.titleSecondary}>{imageTitleSecondary}</div>
                )}
                <div className={styles.titlePrimary}>{imageTitlePrimary}</div>
            </div>
        </div>
    );

    if (imageLink) {
        return (
            <a href={imageLink} className={styles.imageModuleLink} onClick={trackClick}>
                {imageEl}
            </a>
        );
    }

    return imageEl;
};

SiteNavDropdownImageModuleComponent.propTypes = {
    navigationModule: PropTypes.object,
};

export const SiteNavDropdownImageModule = createFragmentContainer(
    SiteNavDropdownImageModuleComponent,
    {
        navigationModule: graphql`
            fragment SiteNavDropdownImageModule_navigationModule on NavigationModule {
                imageUrl
                imageLink
                imageTitlePrimary
                imageTitleSecondary
                imageHeight
                imageWidth
            }
        `,
    }
);
